module.exports = __webpack_public_path__ + "img/skull_6.4d79d716.png";